@if (view$ | async; as view) {
    @if (view.noActivatedChildren) {
        <div class="container-fluid pb-3">
            <div class="w-100 text-end">
                <div class="btn-group" style="margin: 1rem 0">
                    <button
                        class="btn btn-outline-primary"
                        (click)="handleCreateClick(view.validMeters)">
                        {{ 'monitoring_create_consumption_agent' | translate }}
                    </button>
                    <button
                        type="button"
                        class="btn mx-1 btn-outline-primary"
                        (click)="viewMode.set('card')">
                        <i
                            class="bi bi-border-all"
                            style="vertical-align: middle; display: inline-flex"></i>
                    </button>
                    <button
                        type="button"
                        class="btn btn-outline-primary"
                        (click)="viewMode.set('table')">
                        <i
                            class="bi bi-list-ul"
                            style="vertical-align: middle; display: inline-flex"></i>
                    </button>
                </div>
            </div>
            @if (!view.consumptionAgents.loading) {
                @if (viewMode() === 'table') {
                    <app-consumption-agent-table
                        [consumptionAgents]="view.consumptionAgents.value"
                        (editConsumptionAgent)="
                            editAgent($event, view.buildingNo, view.validMeters)
                        "
                        (deleteConsumptionAgent)="
                            deleteAgent(view.buildingNo, $event.reportId, $event.agentName)
                        "
                        (duplicateConsumptionAgent)="duplicateAgent(view.buildingNo, $event)" />
                } @else {
                    <app-consumption-card-view
                        [consumptionAgents]="view.consumptionAgents.value"
                        [buildingNo]="view.buildingNo"
                        (editConsumptionAgent)="
                            editAgent($event, view.buildingNo, view.validMeters)
                        "
                        (deleteConsumptionAgent)="
                            deleteAgent(view.buildingNo, $event.reportId, $event.agentName)
                        "
                        (duplicateConsumptionAgent)="duplicateAgent(view.buildingNo, $event)" />
                }
            }
        </div>
    }
}

<router-outlet />
